import { Navigate, Outlet } from 'react-router-dom'
import { selectIsSuperAdmin, useAuthStore } from '@/stores/authStore'

/** Routes for the platform owner only (the API enforces `require_super_admin` too). */
export function SuperAdminGuard() {
  const isSuperAdmin = useAuthStore(selectIsSuperAdmin)
  return isSuperAdmin ? <Outlet /> : <Navigate to='/unauthorized' replace />
}

export default SuperAdminGuard
